



















































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import UUIFComponents from '@/shared/uuifComponent';
import { InfoState } from '@/core/core.store';
import MswAppTitle from '@/shared/msw-app-title/msw-app-title.vue';
import { SwTextarea } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SwModal, SwModalBody, SwModalFooter } from '@sonicwall/unified-ui-framework/src/shared/sw-modal';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { envCongif } from '@/shared/env.config';
import axios from 'axios';
import { PageTitleConfig } from '../../../shared/msw-app-title/type';

const cssPrefix = 'ipt-approve';

@Component({
  components: {
    ...UUIFComponents,
    MswAppTitle,
    SwTextarea,
    SwButton,
    SwModal,
    SwModalBody,
    SwModalFooter,
  },
})

export default class MswIPT extends SwExtendedVue {
  cssPrefix = cssPrefix;
  comments: string = '';
  showErr: boolean = false;
  showComment: boolean = false;
  invalidUrlMsg: string = '';
  showInvalidUrlMsg: boolean = false;
  disableActions: boolean = false;
  showConfirmationDailog: boolean = false;
  productDetails: any = {};
  showDetails: boolean = false;
  get getHeaderConfig(): PageTitleConfig {
    let title = '';
    if (this.$route.query.status === 'approve') {
      title = (this.$t('registerProduct.aproveHeader')
      .toString());
    } else if (this.$route.query.status === 'decline') {
      title = (this.$t('registerProduct.rejectHeader')
      .toString());
    } else {
      title = (this.$t('registerProduct.iptHeader')
      .toString());
    }
    return {
      pageTitle: title,
      pageParentName: '',
      isShowDashboardIcon: false,
      isShowSlash: false,
    };
  }

  created() {
    this.checkForEmptyQuery();
  }

  checkForEmptyQuery() {
    if (this.$route.query.status === null || this.$route.query.status === undefined
    || this.$route.query.status === 'undefined' || this.$route.query.status === ''
    || this.$route.query.tempToken === null || this.$route.query.tempToken === ''
    || (this.$route.query.status !== 'decline' && this.$route.query.status !== 'approve')) {
      this.invalidUrlMsg = (this.$t('registerProduct.invalidURLmsg')
      .toString());
      this.showInvalidUrlMsg = true;
    } else {
      this.showPreview();
      if (this.$route.query.status === 'decline') this.showComment = true;
    }
  }

  showPreview() {
    this.showDetails = false;
    const URL = `${envCongif.api_url}/product/approve-reject-device`;
    const req = {
      tempCode: this.$route.query.tempToken,
      mode: 'PREVIEW',
    };
    this.$store.commit('startLoading');
    axios.post(URL, req, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(async (res: any) => {
      this.$store.commit('stopLoading');
      if (res) {
        if (res.data.operationStatus === 'OK') {
          this.productDetails = res.data.content;
          this.disableActions = false;
          this.showDetails = true;
        } else {
          const message: InfoState = { infoType: 'failed', infoMsg: res.data.msgDesc };
          this.$store.commit('enqueueMessage', message);
          this.disableActions = true;
        }
      }
    })
    .catch((e: any) => {
      console.warn(e);
      this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: (this.$t('systemMessages.wrong')
      .toString()) });
    });
  }

  approveWithAPIcall() {
    const URL = `${envCongif.api_url}/product/approve-reject-device`;
    const req = {
      tempCode: this.$route.query.tempToken,
      mode: 'APPROVE',
    };
    this.$store.commit('startLoading');
    axios.post(URL, req, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(async (res: any) => {
      this.$store.commit('stopLoading');
      this.showConfirmationDailog = false;
      if (res.data.operationStatus === 'OK') {
        const message: InfoState = { infoType: 'success', infoMsg: res.data.msgDesc };
        this.$store.commit('enqueueMessage', message);
      } else {
        const message: InfoState = { infoType: 'failed', infoMsg: res.data.msgDesc };
        this.$store.commit('enqueueMessage', message);
      }
    });
  }

  rejecttWithAPIcall() {
    if (this.comments === '') {
      this.showErr = true;
    } else {
      const URL = `${envCongif.api_url}/product/approve-reject-device`;
      const req = {
        tempCode: this.$route.query.tempToken,
        mode: 'REJECT',
        comments: this.comments,
      };
      this.$store.commit('startLoading');
      axios.post(URL, req, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then(async (res: any) => {
        this.$store.commit('stopLoading');
        if (res.data.operationStatus === 'OK') {
          const message: InfoState = { infoType: 'success', infoMsg: res.data.msgDesc };
          this.$store.commit('enqueueMessage', message);
          this.comments = '';
        } else {
          const message: InfoState = { infoType: 'failed', infoMsg: res.data.msgDesc };
          this.$store.commit('enqueueMessage', message);
        }
      });
    }
  }
}
